import { render } from "./ResetPassword.vue?vue&type=template&id=eba30764&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=eba30764&scoped=true&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba30764"]])

export default __exports__